import './AnnotationStatusBadge.scss';
import { useTranslator } from '@Localization';
import classNames from 'classnames';
import { ReactElement } from 'react';
import { AnnotationStatus } from '../../../../__legacy__/modules/annotation/annotations.interface';
import { ImageAnnotationStatus } from '../../../../__legacy__/modules/projectDetails/sub/images/projectDetailsImages.model';
import { StatusBadge } from '../../../../design/statusBadge/StatusBadge';
import { getAnnotationStatusText } from '../../../annotations/getAnnotationStatusText';

interface IAnnotationStatusBadgeProps {
  annotationStatus: AnnotationStatus | ImageAnnotationStatus;
}

export const AnnotationStatusBadge = ({ annotationStatus }: IAnnotationStatusBadgeProps): ReactElement => {
  const { t } = useTranslator();

  const key = getAnnotationStatusText(annotationStatus);

  return (
    <StatusBadge
      className={classNames('annotation-status-badge', annotationStatus.toLowerCase())}
      text={key ? t(key) : ''}
    />
  );
};
